import { createAction, props } from "@ngrx/store"
import { CalculationMeta, CostRevenue, HeadlineToEffectiveMeta } from "../types"
import { ValuationLeaseType } from "../types/valuation-process"

export const updateHeadlineToEffectiveOfLease = createAction(
  '[Valuation Process Page - V2 / Valuation Tab] Update Headline to Effective Rent',
  props<{
    uuid: string,
    kind: CostRevenue['kind']
    meta: HeadlineToEffectiveMeta
  }>()
)

export const updateModelAssumptions = createAction(
  '[Valuation Process Page - V2 / Valuation Tab] Update Calculation Meta',
  props<{
    uuid: string,
    kind: CostRevenue['kind'] 
    data: Partial<CalculationMeta>
  }>()
)

export const updateModelAssumptionOfValueAsAWhole = createAction(
  '[Valuation Process Page - V2 / Valuation Tab] Update Value as a whole form change',
  props<{
    passingRent: number,
    grossMarketRentAssessment: 'comp-page' | 'upload',
    grossMarketRent: number,
    leasableAreas: {
      id: number,
      propertySubTypeId: number,
      leasableArea: number
    }[],
    methodId: number,
    timingId: number,
    changeToGrossMarketDefault: boolean,
    capitalRate: number,
    purchaserCost: number,
    estimatedVoidPeriod: number,
    opex: number,
    voidPeriodAllowance: number,
    startDate: Date,
    leaseDuration: number,
    rentReviewTypeId: number,
    rentReviewCycle: number,
    writeOffPeriodAfter: number,
    breakOptionAfter: number,
    activeBreakOption: boolean,
    growthRatePerYear: number,
    allRiskYield: number,
    reversionaryYield: number,
    fixedRentIncreaseType: string,
    fixedRentIncreaseNumber: number,
    fixedRentIncreasePercentage: number,
  }>()
)

export const uploadComparableFile = createAction(
  '[Valuation Process Page - V2 / Valuation Tab] Upload comparable csv file',
  props<{
    name: string,
    path: string
  }>()
)

export const updateMethodAndTiming = createAction(
  '[Valuation Process Page - V2 / Valuation Tab] Update Method and Timing',
  props<{
    uuid: string,
    kind: CostRevenue['kind'],
    data: {
      methodId: number,
      timingId: number,
      exchangeRate: number,
      reportingToLeaseCurrency: boolean
    }
  }>()
)

export const updateValuationType = createAction(
  '[Valuation Process Page - V2 / Valuation Tab] Update Valuation Type',
  props<{
    valuationType: ValuationLeaseType
  }>()
)

export const updateValuationDate = createAction(
  '[Valuation Process Page - V2 / Valuation Tab] Update Valuation Date',
  props<{
    valuationDate: Date
  }>()
)

export const updateSubLease = createAction(
  '[Valuation Process Page - V2 / Valuation Tab] Update Sub Lease',
  props<{
    uuid: string,
    kind: CostRevenue['kind'],
    data: CostRevenue
  }>()
)

export const updateSubLeaseHeadlineToEffectiveMeta = createAction(
  '[Valuation Process Page - V2 / Valuation Tab] Update Sub Lease Headline To Effective Meta',
  props<{
    uuid: string,
    kind: CostRevenue['kind']
    meta: HeadlineToEffectiveMeta
  }>()
)
